import React, { useEffect, Component } from "react"
import MetaTags from 'react-meta-tags';
import { apiEndpoint } from "helpers/url_helper";

import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"

import { Link } from "react-router-dom"

import { connect } from "react-redux";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import DeviceList from "./deviceList";
import AddDevice from "./addDevice";
import FirmwareConfig from "./firmwareConfig";

import classnames from "classnames"

class DeviceManagementTabs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      locationListData : [],
      breadcrumbItems: [
        { title: "Settings", link: "#" },
        { title: "Register Device", link: "/DeviceManagementTabs" },
      ],

      activeTab: "1",
      activeTab1: "5",
      activeTab2: "9",
      activeTab3: "13",
      verticalActiveTab: "1",
      customActiveTab: "1",
      activeTabJustify: "5",
      col1: true,
      col2: false,
      col3: false,
      col5: true,
      col6: true,
      col7: true,
      col8: true,
      col9: true,
      col10: false,
      col11: false,
    }
    this.toggle = this.toggle.bind(this)
    this.toggle1 = this.toggle1.bind(this)

    this.t_col1 = this.t_col1.bind(this)
    this.t_col2 = this.t_col2.bind(this)
    this.t_col3 = this.t_col3.bind(this)
    this.t_col5 = this.t_col5.bind(this)
    this.t_col6 = this.t_col6.bind(this)
    this.t_col7 = this.t_col7.bind(this)
    this.t_col8 = this.t_col8.bind(this)
    this.t_col9 = this.t_col9.bind(this)
    this.t_col10 = this.t_col10.bind(this)
    this.t_col11 = this.t_col11.bind(this)

    this.toggle2 = this.toggle2.bind(this)
    this.toggle3 = this.toggle3.bind(this)

    this.toggleVertical = this.toggleVertical.bind(this)
    this.toggleCustom = this.toggleCustom.bind(this)
  }

  componentDidMount() {
    this.props.setBreadcrumbItems("Register Device", this.state.breadcrumbItems);
    //this._locationList();
  }

  _locationList() {
    debugger;
    fetch(
      // UserValidated
      apiEndpoint+"/getLocationDetails",
      {
        method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                "intCampusID": 1,
                "strToken": sessionStorage.getItem("Clear_AuthUser")
              })
      }
    )
      .then(res => res.json())
      .then(response =>
        this.setState({ locationListData: response.items })
      
      )
      .catch(error => console.log(error));
  }

  t_col1() {
    this.setState({ col1: !this.state.col1 })
  }

  t_col2() {
    this.setState({ col2: !this.state.col2 })
  }

  t_col3() {
    this.setState({ col3: !this.state.col3 })
  }

  t_col5() {
    this.setState({ col5: !this.state.col5 })
  }

  t_col6() {
    this.setState({ col6: !this.state.col6 })
  }

  t_col7() {
    this.setState({ col7: !this.state.col7 })
  }

  t_col8() {
    this.setState({
      col6: !this.state.col6,
      col7: !this.state.col7
    })
  }

  t_col9() {
    this.setState({ col9: !this.state.col9 })
  }

  t_col10() {
    this.setState({ col10: !this.state.col10 })
  }

  t_col11() {
    this.setState({ col11: !this.state.col11 })
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }

  toggle1(tab) {
    if (this.state.activeTab1 !== tab) {
      this.setState({
        activeTab1: tab,
      })
    }
  }

  toggle2(tab) {
    if (this.state.activeTab2 !== tab) {
      this.setState({
        activeTab2: tab,
      })
    }
  }

  toggle3(tab) {
    if (this.state.activeTab3 !== tab) {
      this.setState({
        activeTab3: tab,
      })
    }
  }

  toggleVertical(tab) {
    if (this.state.verticalActiveTab !== tab) {
      this.setState({
        verticalActiveTab: tab,
      })
    }
  }

  toggleCustom(tab) {
    if (this.state.customActiveTab !== tab) {
      this.setState({
        customActiveTab: tab,
      })
    }
  }


  render() {
    return (
      <React.Fragment>
        <MetaTags>
          <title>Indus | Device Management</title>
        </MetaTags>
        <Row>

          <Col lg={12}>
            <Card>
              <CardBody>
                <div>
                  <Nav pills className="navtab-bg nav-justified">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: this.state.activeTab1 === "5",
                        })}
                        onClick={() => {
                          this.toggle1("5")
                        }}
                      >
                        List Of Devices
                      </NavLink>
                    </NavItem>
                    {/*<NavItem>*/}
                    {/*  <NavLink*/}
                    {/*    style={{ cursor: "pointer" }}*/}
                    {/*    className={classnames({*/}
                    {/*      active: this.state.activeTab1 === "6",*/}
                    {/*    })}*/}
                    {/*    onClick={() => {*/}
                    {/*      this.toggle1("6")*/}
                    {/*    }}*/}
                    {/*  >*/}
                    {/*    Device Configuration*/}
                    {/*  </NavLink>*/}

                    {/*</NavItem>*/}
                    {/*<NavItem>*/}
                    {/*  <NavLink*/}
                    {/*    style={{ cursor: "pointer" }}*/}
                    {/*    className={classnames({*/}
                    {/*      active: this.state.activeTab1 === "7",*/}
                    {/*    })}*/}
                    {/*    onClick={() => {*/}
                    {/*      this.toggle1("7")*/}
                    {/*    }}*/}
                    {/*  >*/}
                    {/*    Firmware Configuration*/}
                    {/*  </NavLink>*/}

                    {/*</NavItem>*/}


                  </Nav>
                  <TabContent activeTab={this.state.activeTab1} className="p-3 text-muted">
                    <TabPane tabId="5">
                      <Row>
                        <Col sm="12">
                          <DeviceList />
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="6">
                      <Row>
                        <Col sm="12">
                          <AddDevice />
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="7">
                      <Row>
                        <Col sm="12">
                          <FirmwareConfig />
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </div>

              </CardBody>
            </Card>
          </Col>
        </Row>

      </React.Fragment>
    )
  }
}

export default connect(null, { setBreadcrumbItems })(DeviceManagementTabs);